"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertIsObject = exports.isObject = exports.hasProperty = void 0;
const assertion_exception_1 = require("../#lib/exceptions/assertion-exception");
// eslint-disable-next-line @typescript-eslint/ban-types
function hasProperty(property, subject) {
    return property in subject;
}
exports.hasProperty = hasProperty;
function isObject(subject) {
    return typeof subject === 'object' && subject !== null;
}
exports.isObject = isObject;
function assertIsObject(subject) {
    if (!isObject(subject)) {
        throw new assertion_exception_1.AssertionException('The given value is not an `object`.');
    }
}
exports.assertIsObject = assertIsObject;
//# sourceMappingURL=#object.js.map